// export const API = {
//   __REST_API_URL: "https://api.fouassin-gmao.fr/demo",
//   __SOCKET_URL: "https://api.fouassin-gmao.fr",
//   __SOCKET_PATH: "/demo/socket.io",
// };


export const API = {
  __REST_API_URL: "https://api.fouassin-gmao.fr/orange",
  __SOCKET_URL: "https://api.fouassin-gmao.fr",
  __SOCKET_PATH: "/orange/socket.io",
};



// WEBPACK FOOTER //
// ./src/config/Api.ts